import { GetFlightItineraryShareLinkState } from './getFlightItineraryShareLink.types'

const initialState: GetFlightItineraryShareLinkState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
